module.exports = __webpack_public_path__ + "static/media/confirm.33cef19b.jpg";